module.exports = __webpack_public_path__ + "static/hariswbg-39662f7278d98e77d132efb7b141de5a.png";